import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  COMPANY_NAME,
  TAGLINE,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  WEBSITE,
  LOGO_BLACK,
  ROBOT_IMAGE,
  WAVE_SVG,
} from './branding';
import './LetterPadFrame.css';

/**
 * Shared letter-pad chrome for HTML → PDF (html2canvas) documents.
 * Smooth blue→pink gradient header (profile-card style), black logo, robot, wave.
 */
export default function LetterPadFrame({ children, sx = {} }) {
  return (
    <Box
      className="letter-pad-frame"
      sx={{
        bgcolor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        ...sx,
      }}
    >
      <Box className="letter-pad-header" component="header">
        <Box className="letter-pad-header-band">
          <Box className="letter-pad-header-row">
            <Box className="letter-pad-logo-badge">
              <Box
                component="img"
                src={LOGO_BLACK}
                alt={COMPANY_NAME}
                className="letter-pad-logo"
              />
            </Box>

            <Box className="letter-pad-title-block">
              <Typography className="letter-pad-company">{COMPANY_NAME}</Typography>
              <Typography className="letter-pad-tagline">{TAGLINE}</Typography>
            </Box>

            <Box className="letter-pad-robot-badge">
              <Box
                component="img"
                src={ROBOT_IMAGE}
                alt=""
                className="letter-pad-robot"
                crossOrigin="anonymous"
              />
            </Box>
          </Box>

          <svg
            className="letter-pad-wave"
            viewBox="0 0 210 40"
            preserveAspectRatio="none"
            aria-hidden
          >
            <path d={WAVE_SVG} fill="#ffffff" />
          </svg>
        </Box>
      </Box>

      <Box className="letter-pad-body" sx={{ flex: 1, px: { xs: 2.5, md: 4 }, py: { xs: 2.5, md: 3 } }}>
        {children}
      </Box>

      <Box className="letter-pad-footer" component="footer">
        <Box className="letter-pad-footer-rule" />
        <Typography className="letter-pad-footer-text">
          {CONTACT_EMAIL}
          <span className="letter-pad-dot"> · </span>
          {CONTACT_PHONE}
          <span className="letter-pad-dot"> · </span>
          {WEBSITE}
        </Typography>
      </Box>
    </Box>
  );
}
